import React from "react";
import { useYearOverview } from "../../hooks/useYearOverview";
import YearMonthRow from "./YearMonthRow";

interface YearOverviewTabProps {
  organizationId: string | null | undefined;
  year: number;
  dayStart: number;
  dayEnd: number;
}

const YearOverviewTab: React.FC<YearOverviewTabProps> = ({
  organizationId,
  year,
  dayStart,
  dayEnd,
}) => {
  const { data, isLoading, error } = useYearOverview(organizationId, year, dayStart, dayEnd);

  if (error) {
    return (
      <div className="liquid-glass anim-lift p-8 text-center text-glass-muted">
        Failed to load year overview: {error}
      </div>
    );
  }

  if (isLoading || !data) {
    return (
      <div className="space-y-6">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={`skel-${i}`} className="liquid-glass min-h-[280px] anim-skeleton" />
        ))}
      </div>
    );
  }

  if (data.months.length === 0) {
    return (
      <div className="liquid-glass anim-lift p-8 text-center text-glass-muted">
        No data for {year}.
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {data.months.map((month) => (
        <YearMonthRow key={month.month_num} month={month} year={year} />
      ))}
    </div>
  );
};

export default YearOverviewTab;
